/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FoundInputs */

const en_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`found)`)
};

const es_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`encontrados)`)
};

const fr_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trouvés)`)
};

const de_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gefunden)`)
};

const ja_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`件見つかりました)`)
};

const zh_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`个结果)`)
};

const ar_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم العثور)`)
};

const id_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ditemukan)`)
};

const it_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trovati)`)
};

const ru_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`найдено)`)
};

const pt_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`encontrados)`)
};

const ko_found = /** @type {(inputs: FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개 발견)`)
};

/**
* | output |
* | --- |
* | "found)" |
*
* @param {FoundInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const found = /** @type {((inputs?: FoundInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FoundInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_found(inputs)
	if (locale === "es") return es_found(inputs)
	if (locale === "fr") return fr_found(inputs)
	if (locale === "de") return de_found(inputs)
	if (locale === "ja") return ja_found(inputs)
	if (locale === "zh") return zh_found(inputs)
	if (locale === "ar") return ar_found(inputs)
	if (locale === "id") return id_found(inputs)
	if (locale === "it") return it_found(inputs)
	if (locale === "ru") return ru_found(inputs)
	if (locale === "pt") return pt_found(inputs)
	return ko_found(inputs)
});